<script setup lang="ts">
import { useCustomerStore, useGlobalStore, useQuoteStore } from "@/stores";
import KeyInformation from "@/components/general/KeyInformation/KeyInformation.vue";

const quote = useQuoteStore();
const global = useGlobalStore();
const customer = useCustomerStore();
</script>
<template>
    <div class="summary-box">
        <div class="inner">
            <p>
                <span class="title">Your cash sum</span>
            </p>
            <p>
                <span id="cashSum" class="text">
                    £{{ global.formatNumber(quote.mySA) }} - The full cash sum
                    is payable after one year of starting the plan, or within
                    the first year if you die as the result of an accident.
                </span>
                <span class="text">
                    You will stop paying your premiums at age 90, however the
                    policy will continue for the rest of your life. If you were
                    to take out a policy today for £{{
                        global.formatNumber(quote.myPPM)
                    }}
                    per month, by age {{ quote.myBreakEvenAge }}, you will have
                    paid as much in premiums as the cash sum.
                </span>
            </p>
        </div>
        <div class="inner">
            <p>
                <span class="title">Max payment term</span>
            </p>
            <p>
                <span id="paymentTerm" class="text">
                    {{ 90 - customer.age }} years
                </span>
            </p>
        </div>
        <div class="inner">
            <p>
                <span class="title">Max cover amount</span>
            </p>
            <p>
                <span id="maxCover" class="text">
                    Please make sure the total cash sum for all your L&G Over
                    50s Life Insurance plans is not greater than £10,000. If you
                    have a plan taken out on or before 25 November 2017, please
                    refer to your policy terms and conditions for your total
                    cash sum.
                </span>
            </p>
        </div>
        <div class="key-info-container">
            <KeyInformation />
        </div>
    </div>
</template>

<style scoped>
.summary-box {
    border: 1px solid var(--color-border);
    background: var(--pure-white);
    padding: 20px;

    .inner {
        display: grid;
        background: var(--grey-lightest);

        p {
            font-size: 0.9rem;
            padding: 0.5rem;
            margin-bottom: 0;

            span {
                display: block;

                &.title {
                    font-weight: bold;
                }
            }
        }

        p:nth-child(odd) {
            padding-bottom: 0;
        }

        p:nth-child(even) {
            padding-top: 0;
        }
    }

    .key-info-container {
        font-size: 0.9rem;
        background: var(--grey-lightest);
        padding: 1rem 0.5rem 2rem;
    }
}

@media screen and (width >= 585px) {
    .summary-box {
        .inner {
            grid-template-columns: 25% 75%;

            p:nth-child(odd) {
                padding-bottom: 0.5rem;
            }

            p:nth-child(even) {
                padding-top: 0.5rem;
            }
        }
    }
}

@media screen and (width >= 993px) {
    .key-info-container {
        display: none;
    }
}
</style>
